
export const WorkflowsVals = {
    ProjectDocumentationApproval : 1,
    WorkingDocumentationApproval : 2,
    TechSpecsApproval : 3,
    TechSpecsChangesApproval : 4,
    ContractorProjectDocumentationWorking : 5,
    ExecutiveDocumentationApproval: 9
}